// Configuração da API para o frontend
const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://backend.fastnotify.com.br'
};

export default config;
